module.exports = __webpack_public_path__ + "img/Feature.01551983.png";